import React from 'react'
import { CardHeader, Typography } from '@mui/material';

const Formula = ({width}) => {
    return ( <div className='colorbase text-center' style={{paddingTop: 100}}>
        <div>
            <CardHeader title={(<h2 className='text-lighting'>ประมาณการเงิน กบข. ในเมนู My GPF & My GPF Twins</h2>)} subheader={(<h2 className='colorbase'>คำนวณโดยแบบจำลองทางสถิติและสมมติฐานต่างๆ</h2>)} />
        </div>
        <div className='justify-content-center'>
            <div className='w-100 container'>
                <div>
                    <Typography className='mt-3 justify-content-center'>
                        ประมาณการเงินจาก กบข. และประมาณการเงินบำนาญ ณ วันเกษียณ เกิดจากการประมวลผลด้วยแบบจำลองทางสถิติโดยอาศัยข้อมูลจากการประเมินสถานการณ์การลงทุน รวมทั้งสมมติฐานและข้อมูลประมาณการ โดยอยู่ภายใต้ข้อสงวนสิทธิ์ (Disclaimer) ของ กบข. ดังนี้
                    </Typography>
                </div>
            <div className={'col-12 justify-content-center container mt-5 ' + (width > 1200 ? 'row' : '')}>
                <div className={'col-md-12' + (width > 900 ? ' pl-5' : '')}>
                    <Typography variant='h5' className='text-left mt-3'>
                        1. สมมติฐาน
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (1) การคาดการณ์ผลตอบแทนที่จะเกิดขึ้นในอนาคตเป็นไปตามสัดส่วนของหลักทรัพย์ นโยบายและแผนการลงทุน ดังนี้
                    </Typography>
                    <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset12.webp' className='mt-4' width={width > 1200 ? '60%' : '100%'} />
                    <Typography className='text-left mt-3 pl-4'>
                        (2) ประมาณการอัตราเงินเฟ้อ 2.5% ต่อปี
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (3) คํานวณตั้งต้นจากยอดเงินในบัญชีรายบุคคลของ สมาชิก ณ ปัจจุบัน
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (4) คํานวณตั้งต้นจากเงินเดือนปัจจุบันตามข้อมูลที่ปรากฏจากฐานข้อมูล กบข. และมีสมมติฐานว่าสมาชิกมีการปรับขึ้นเงินเดือน 2 ครั้งต่อปี ครั้งละ 3% ในเดือนเมษายนและตุลาคมของทุกปี โดยมีอัตราเงินเดือนขั้นสูงสุดตามโครงสร้างเงินเดือนของกรมบัญชีกลาง
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (5) สมาชิกเกษียณอายุราชการในวันที่ 30 กันยายน เมื่อมีอายุครบตามที่กําหนดไว้ในระเบียบของข้าราชการแต่ละประเภท
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (6) สมาชิกมีสิทธิและเลือกรับบํานาญเมื่อเกษียณอายุราชการ
                    </Typography>
                </div>
                <div className={'col-md-12' + (width > 900 ? ' pl-5' : '')}>
                    <Typography variant='h5' className='text-left mt-3'>
                        2. สมมติฐานการประมาณการเงินบํานาญ
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (1) ใช้สูตรในการคํานวณเงินบํานาญสมาชิก กบข. ดังนี้
                    </Typography>
                    <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset13.webp' className='mt-4' width={width > 1200 ? '60%' : '100%'} />
                    <Typography className='text-left mt-3 pl-4'>
                        (2) คํานวณตั้งต้นจากเงินเดือนปัจจุบันตามฐานข้อมูลที่ปรากฏจากฐานข้อมูล กบข. และมีสมมติฐานว่าสมาชิกมีการปรับขึ้นเงินเดือน 2 ครั้งต่อปี ครั้งละ 3% ในเดือนเมษายนและตุลาคมของทุกปี โดยมีอัตราเงินเดือนขั้นสูงสุดตามโครงสร้างเงินเดือนของกรมบัญชีกลาง
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (3) การคํานวณเวลาราชการจะคิดจากวันเริ่มต้นรับราชการจนถึงวันเกษียณ ซึ่งไม่รวมถึงเวลาราชการทวีคูณหรือเวลาราชการที่ต้องถูกหักออก เนื่องจากการลาไปศึกษา ฝึกอบรม ดูงาน หรือปฏิบัติการวิจัย หรือไปสมัครรับเลือกตั้ง หรือด้วยเหตุอื่นใด
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        (4) คํานวณตั้งต้นจากเงินเดือนปัจจุบันตามข้อมูลที่ปรากฏจากฐานข้อมูล กบข. และมีสมมติฐานว่าสมาชิกมีการปรับขึ้นเงินเดือน 2 ครั้งต่อปี ครั้งละ 3% ในเดือนเมษายนและตุลาคมของทุกปี โดยมีอัตราเงินเดือนขั้นสูงสุดตามโครงสร้างเงินเดือนของกรมบัญชีกลาง
                    </Typography>
                    <Typography className='text-left mt-5 pl-4'>
                        <b>ข้อสงวนสิทธิ์ :</b> การลงทุนย่อมมีความเสี่ยงและผลตอบแทนจากการลงทุนอาจมีความผันผวนขึ้นอยู่กับปัจจัยทางเศรษฐกิจ สถานการณ์การลงทุน และข้อมูลที่ใช้ในการคํานวณในแต่ละช่วงเวลา ดังนั้น <b>กบข. จึงไม่ได้รับประกันว่า</b> จํานวนเงิน กบข. และจํานวนเงินบํานาญที่ได้จากการประมวลผลด้วย แอปพลิเคชันของ กบข. จะเป็นจํานวนเงินที่สมาชิกจะได้รับจริงเมื่อสมาชิกออกจากราชการ
                    </Typography>
                    <Typography className='text-left mt-3 pl-4'>
                        <b>ข้อมูลเพิ่มเติม :</b> สมาชิกที่มีข้อสงสัยหรือต้องการสอบถามข้อมูลเพิ่มเติม โปรดติดต่อ กรมบัญชีกลาง โทร. 0 2270 6400 หรือสํานักงานคลังเขต ของกรมบัญชีกลางทุกแห่ง
                    </Typography>
                </div>
            </div>
            </div>
        </div>
    
    </div> );
}
 
export default Formula;